import { CatBreed } from "@/primary-models";
import type { TCatDefaultValues } from "@./state";
import {
  activityLevels,
  bodyTypes,
  type TCatFormDataInput,
} from "@./suf-store";
import type {
  CatCount,
} from "apps/website/components/pages/flows/fresh/sign-up/CatCount/constants";

/*
 * Default answers for the sign-up flow.
 *
 * - `TCatDefaultValues` are applied with `useApplyCatDefaults`. They're module-level
 *   constants so their reference is stable across renders.
 * - The cat count is the initial state of `useCatCountForm`.
 * - The grown cat birth month is set by `useLifeStageLogic` when the user continues.
 */

const NO_DEFAULTS: TCatDefaultValues = {};

export function getDefaultCatCount(isShorterSufTest: boolean): CatCount | null {
  return isShorterSufTest ? 1 : null;
}

const SHORTER_SUF_BASIC_INFORMATION_DEFAULTS: TCatDefaultValues = {
  breed: CatBreed.DOMESTIC_SHORT_HAIR,
};

export function getBasicInformationDefaults(isShorterSufTest: boolean): TCatDefaultValues {
  return isShorterSufTest ? SHORTER_SUF_BASIC_INFORMATION_DEFAULTS : NO_DEFAULTS;
}

const SHORTER_SUF_AGE_DEFAULTS: TCatDefaultValues = { isNeutered: true };

export function getAgeDefaults(
  showNeuteredSection: boolean,
  isShorterSufTest: boolean,
): TCatDefaultValues {
  return isShorterSufTest && showNeuteredSection ? SHORTER_SUF_AGE_DEFAULTS : NO_DEFAULTS;
}

export function shouldDefaultGrownCatBirthdayMonth(
  cat: TCatFormDataInput | undefined,
  isShorterSufTest: boolean,
): boolean {
  return isShorterSufTest && !!cat?.lifeStage && cat.lifeStage !== "kitten" && !cat.birthdayMonth;
}

export const FITNESS_DEFAULTS: TCatDefaultValues = {
  "body.bodyType": bodyTypes.JUST_RIGHT,
  "body.activityLevel": activityLevels.INDOOR_AND_OUTDOOR,
};

export const MEDICAL_CONDITIONS_DEFAULTS: TCatDefaultValues = {
  "medical.hasConditions": false,
  "diet.foodAllergies.hasAllergies": false,
};
